import { useWindowWidth } from "@tecnobit-srl/hook-use-window-width";
const tokens = {
  "aspectRatios.square": {
    "value": "1 / 1",
    "variable": "var(--cUJial)"
  },
  "aspectRatios.landscape": {
    "value": "4 / 3",
    "variable": "var(--joSgrv)"
  },
  "aspectRatios.portrait": {
    "value": "3 / 4",
    "variable": "var(--dXjFHz)"
  },
  "aspectRatios.wide": {
    "value": "16 / 9",
    "variable": "var(--gqpqIn)"
  },
  "aspectRatios.ultrawide": {
    "value": "18 / 5",
    "variable": "var(--lixcAJ)"
  },
  "aspectRatios.golden": {
    "value": "1.618 / 1",
    "variable": "var(--hSWVDT)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--dzOvWn)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--drrWcF)"
  },
  "easings.linear": {
    "value": "linear",
    "variable": "var(--hgfxJf)"
  },
  "easings.in": {
    "value": "cubic-bezier(0.4, 0, 1, 1)",
    "variable": "var(--hCLxzh)"
  },
  "easings.out": {
    "value": "cubic-bezier(0, 0, 0.2, 1)",
    "variable": "var(--byCBno)"
  },
  "easings.in-out": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--gSAVQW)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--fuVfvZ)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--fVBMec)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--mUhz)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--cWTXGg)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--cifMdM)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--goNNlj)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--bPXfWW)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--ixNmpi)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--bewZvn)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--kLOfAE)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--dxfumK)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--UXfgJ)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--bphCwb)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--eougbK)"
  },
  "radii.4xl": {
    "value": "2rem",
    "variable": "var(--holyYx)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--kkkBVq)"
  },
  "fontWeights.thin": {
    "value": "100",
    "variable": "var(--dRPRGd)"
  },
  "fontWeights.extralight": {
    "value": "200",
    "variable": "var(--dooANa)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--fVSZDc)"
  },
  "fontWeights.normal": {
    "value": "400",
    "variable": "var(--llFanx)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--leEsKL)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--hmvyHR)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--ghWdwL)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--janwPd)"
  },
  "fontWeights.black": {
    "value": "900",
    "variable": "var(--bvnjIx)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--ekeMrS)"
  },
  "lineHeights.tight": {
    "value": "1.25",
    "variable": "var(--jyTpIu)"
  },
  "lineHeights.snug": {
    "value": "1.375",
    "variable": "var(--ipEwfb)"
  },
  "lineHeights.normal": {
    "value": "1.5",
    "variable": "var(--lomeBD)"
  },
  "lineHeights.relaxed": {
    "value": "1.625",
    "variable": "var(--kwMYUX)"
  },
  "lineHeights.loose": {
    "value": "2",
    "variable": "var(--dVGecO)"
  },
  "fonts.sans": {
    "value": 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    "variable": "var(--dywXPJ)"
  },
  "fonts.serif": {
    "value": 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
    "variable": "var(--guQdxN)"
  },
  "fonts.mono": {
    "value": 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    "variable": "var(--gxQaAd)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--jrseCf)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--glKTKc)"
  },
  "letterSpacings.normal": {
    "value": "0em",
    "variable": "var(--knaPyh)"
  },
  "letterSpacings.wide": {
    "value": "0.025em",
    "variable": "var(--jwdARF)"
  },
  "letterSpacings.wider": {
    "value": "0.05em",
    "variable": "var(--eUSVTv)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--lhSeXO)"
  },
  "fontSizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--kWjDjq)"
  },
  "fontSizes.xs": {
    "value": "0.75rem",
    "variable": "var(--loLyxA)"
  },
  "fontSizes.sm": {
    "value": "0.875rem",
    "variable": "var(--eRgJXV)"
  },
  "fontSizes.md": {
    "value": "1rem",
    "variable": "var(--daFrau)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--gKFLFQ)"
  },
  "fontSizes.xl": {
    "value": "1.25rem",
    "variable": "var(--gFqSQX)"
  },
  "fontSizes.2xl": {
    "value": "1.5rem",
    "variable": "var(--dllMvh)"
  },
  "fontSizes.3xl": {
    "value": "1.875rem",
    "variable": "var(--jaXqkI)"
  },
  "fontSizes.4xl": {
    "value": "2.25rem",
    "variable": "var(--cLogVb)"
  },
  "fontSizes.5xl": {
    "value": "3rem",
    "variable": "var(--izMrAu)"
  },
  "fontSizes.6xl": {
    "value": "3.75rem",
    "variable": "var(--hdlyfR)"
  },
  "fontSizes.7xl": {
    "value": "4.5rem",
    "variable": "var(--bDBsww)"
  },
  "fontSizes.8xl": {
    "value": "6rem",
    "variable": "var(--fwhTbD)"
  },
  "fontSizes.9xl": {
    "value": "8rem",
    "variable": "var(--lkGdGW)"
  },
  "shadows.xs": {
    "value": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    "variable": "var(--bUWovs)"
  },
  "shadows.sm": {
    "value": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    "variable": "var(--cDhNnp)"
  },
  "shadows.md": {
    "value": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    "variable": "var(--jMKUKK)"
  },
  "shadows.lg": {
    "value": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    "variable": "var(--kNVcRA)"
  },
  "shadows.xl": {
    "value": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    "variable": "var(--bnVgij)"
  },
  "shadows.2xl": {
    "value": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    "variable": "var(--IghlV)"
  },
  "shadows.inner": {
    "value": "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
    "variable": "var(--gmhFEB)"
  },
  "blurs.sm": {
    "value": "4px",
    "variable": "var(--aZLOC)"
  },
  "blurs.base": {
    "value": "8px",
    "variable": "var(--jDYzax)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--kMMDaR)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--dyIDQb)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--TtVDs)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--btncja)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--esAhmv)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--fcTUxn)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--dacYEG)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--ebuyxV)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--bYDCFo)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--hIimNX)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--fFrqVq)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--gGIQOF)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--eDRUVY)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--flZesP)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--djiiAi)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--ieMJEa)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--cBFxYr)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--uyqLg)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--hXmVPi)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--mYCWo)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--jgejxp)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--iYEvIx)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--dzpWeZ)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--fifqnK)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--faFCyS)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--bxwoov)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--huPzrf)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--hgdKvb)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--cZMJbQ)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--iXfUeA)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--vWSpd)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--gtqdrN)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--hNtIEu)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--kqIPsj)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--wdMRQ)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--gEfgCY)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--jJIQbV)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--cqwGG)"
  },
  "spacing.3.5": {
    "value": "0.875rem",
    "variable": "var(--dhUgfD)"
  },
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--bJeTGz)"
  },
  "animations.ping": {
    "value": "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    "variable": "var(--cxTetH)"
  },
  "animations.pulse": {
    "value": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    "variable": "var(--jjLJjo)"
  },
  "animations.bounce": {
    "value": "bounce 1s infinite",
    "variable": "var(--eUTuJH)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--kTdGYg)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--cCUBeV)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--gsUKim)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--jshnNX)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--juMtMc)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--beDnSR)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--eUDwWi)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--hTQaBT)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--cAmzCM)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--fzzdix)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--dDnfaV)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--cpjPHA)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--ckODEv)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--hTmzdp)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--gANXGP)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--htnoem)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--tQYHK)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--kcGldO)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--gMkTEx)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--lcknGR)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--kveXIc)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--gsriJI)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--bPcliI)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--Mxqsr)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--hZfkST)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--fUWaSi)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--bSilTO)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--fnTGst)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--dAFdyM)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--jxszKr)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--hghuKL)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--drtIxO)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--siblR)"
  },
  "sizes.3.5": {
    "value": "0.875rem",
    "variable": "var(--hSPYxQ)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--izvCpj)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--aTIGG)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--kMQJUV)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--dyNKmL)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--ToPgI)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--btoFLe)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--esBjqP)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--hrOPNc)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--krbtsN)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--cRFSXi)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--fQSwCT)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--iQceEA)"
  },
  "sizes.prose": {
    "value": "65ch",
    "variable": "var(--jAesVz)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--khWApH)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--eOXrSu)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--jNBRbM)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--UhpHH)"
  },
  "sizes.container": {
    "value": "var(--container-size)",
    "variable": "var(--irAcDv)"
  },
  "sizes.narrowContainer": {
    "value": "var(--narrow-container-size)",
    "variable": "var(--AXQcM)"
  },
  "sizes.breakpoint-sm": {
    "value": "640px",
    "variable": "var(--eomHOU)"
  },
  "sizes.breakpoint-md": {
    "value": "768px",
    "variable": "var(--iujnmj)"
  },
  "sizes.breakpoint-lg": {
    "value": "1024px",
    "variable": "var(--gThSgZ)"
  },
  "sizes.breakpoint-xl": {
    "value": "1280px",
    "variable": "var(--cssArG)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1536px",
    "variable": "var(--jESPPc)"
  },
  "sizes.breakpoint-tablet": {
    "value": "768px",
    "variable": "var(--iCtdVo)"
  },
  "sizes.breakpoint-desktop": {
    "value": "1280px",
    "variable": "var(--koQBGI)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--bLinLB)"
  },
  "colors.black": {
    "value": "#000",
    "variable": "var(--qLIrn)"
  },
  "colors.white": {
    "value": "#fff",
    "variable": "var(--RiClf)"
  },
  "colors.transparent": {
    "value": "rgb(0 0 0 / 0)",
    "variable": "var(--edNtiq)"
  },
  "colors.rose.50": {
    "value": "#fff1f2",
    "variable": "var(--cQacUT)"
  },
  "colors.rose.100": {
    "value": "#ffe4e6",
    "variable": "var(--fFtaKH)"
  },
  "colors.rose.200": {
    "value": "#fecdd3",
    "variable": "var(--eUoFZM)"
  },
  "colors.rose.300": {
    "value": "#fda4af",
    "variable": "var(--bPMUxN)"
  },
  "colors.rose.400": {
    "value": "#fb7185",
    "variable": "var(--bvZVli)"
  },
  "colors.rose.500": {
    "value": "#f43f5e",
    "variable": "var(--jGTTif)"
  },
  "colors.rose.600": {
    "value": "#e11d48",
    "variable": "var(--iVPyxk)"
  },
  "colors.rose.700": {
    "value": "#be123c",
    "variable": "var(--fRnMVl)"
  },
  "colors.rose.800": {
    "value": "#9f1239",
    "variable": "var(--hxzBoW)"
  },
  "colors.rose.900": {
    "value": "#881337",
    "variable": "var(--esXPMX)"
  },
  "colors.rose.950": {
    "value": "#4c0519",
    "variable": "var(--epiLsK)"
  },
  "colors.pink.50": {
    "value": "#fdf2f8",
    "variable": "var(--hPYfGc)"
  },
  "colors.pink.100": {
    "value": "#fce7f3",
    "variable": "var(--ioAkJk)"
  },
  "colors.pink.200": {
    "value": "#fbcfe8",
    "variable": "var(--eyVWNz)"
  },
  "colors.pink.300": {
    "value": "#f9a8d4",
    "variable": "var(--nXIqK)"
  },
  "colors.pink.400": {
    "value": "#f472b6",
    "variable": "var(--hGgStN)"
  },
  "colors.pink.500": {
    "value": "#ec4899",
    "variable": "var(--dviDWY)"
  },
  "colors.pink.600": {
    "value": "#db2777",
    "variable": "var(--kUZZAj)"
  },
  "colors.pink.700": {
    "value": "#be185d",
    "variable": "var(--gKbLdu)"
  },
  "colors.pink.800": {
    "value": "#9d174d",
    "variable": "var(--UhnuV)"
  },
  "colors.pink.900": {
    "value": "#831843",
    "variable": "var(--hYEIxc)"
  },
  "colors.pink.950": {
    "value": "#500724",
    "variable": "var(--dPgAHx)"
  },
  "colors.fuchsia.50": {
    "value": "#fdf4ff",
    "variable": "var(--kpTESD)"
  },
  "colors.fuchsia.100": {
    "value": "#fae8ff",
    "variable": "var(--jfJgr)"
  },
  "colors.fuchsia.200": {
    "value": "#f5d0fe",
    "variable": "var(--gZeVto)"
  },
  "colors.fuchsia.300": {
    "value": "#f0abfc",
    "variable": "var(--gfHpEZ)"
  },
  "colors.fuchsia.400": {
    "value": "#e879f9",
    "variable": "var(--dSTUoK)"
  },
  "colors.fuchsia.500": {
    "value": "#d946ef",
    "variable": "var(--cZwoAv)"
  },
  "colors.fuchsia.600": {
    "value": "#c026d3",
    "variable": "var(--jPvANs)"
  },
  "colors.fuchsia.700": {
    "value": "#a21caf",
    "variable": "var(--iVXUZd)"
  },
  "colors.fuchsia.800": {
    "value": "#86198f",
    "variable": "var(--hYKnEO)"
  },
  "colors.fuchsia.900": {
    "value": "#701a75",
    "variable": "var(--hfmHQz)"
  },
  "colors.fuchsia.950": {
    "value": "#4a044e",
    "variable": "var(--cYPdae)"
  },
  "colors.purple.50": {
    "value": "#faf5ff",
    "variable": "var(--ksTgfC)"
  },
  "colors.purple.100": {
    "value": "#f3e8ff",
    "variable": "var(--iCdJRO)"
  },
  "colors.purple.200": {
    "value": "#e9d5ff",
    "variable": "var(--dWAXWh)"
  },
  "colors.purple.300": {
    "value": "#d8b4fe",
    "variable": "var(--jcWlLI)"
  },
  "colors.purple.400": {
    "value": "#c084fc",
    "variable": "var(--eLlnzT)"
  },
  "colors.purple.500": {
    "value": "#a855f7",
    "variable": "var(--jRGBpu)"
  },
  "colors.purple.600": {
    "value": "#9333ea",
    "variable": "var(--fmdPtN)"
  },
  "colors.purple.700": {
    "value": "#7e22ce",
    "variable": "var(--kszdjo)"
  },
  "colors.purple.800": {
    "value": "#6b21a8",
    "variable": "var(--kMigIv)"
  },
  "colors.purple.900": {
    "value": "#581c87",
    "variable": "var(--eDhKZa)"
  },
  "colors.purple.950": {
    "value": "#3b0764",
    "variable": "var(--eadxYH)"
  },
  "colors.violet.50": {
    "value": "#f5f3ff",
    "variable": "var(--elZfLV)"
  },
  "colors.violet.100": {
    "value": "#ede9fe",
    "variable": "var(--jcWAkV)"
  },
  "colors.violet.200": {
    "value": "#ddd6fe",
    "variable": "var(--gHfMHa)"
  },
  "colors.violet.300": {
    "value": "#c4b5fd",
    "variable": "var(--jSzuYT)"
  },
  "colors.violet.400": {
    "value": "#a78bfa",
    "variable": "var(--jDVPUQ)"
  },
  "colors.violet.500": {
    "value": "#8b5cf6",
    "variable": "var(--bzTONN)"
  },
  "colors.violet.600": {
    "value": "#7c3aed",
    "variable": "var(--ktyKIO)"
  },
  "colors.violet.700": {
    "value": "#6d28d9",
    "variable": "var(--cpwJBL)"
  },
  "colors.violet.800": {
    "value": "#5b21b6",
    "variable": "var(--foWeJc)"
  },
  "colors.violet.900": {
    "value": "#4c1d95",
    "variable": "var(--iApNaV)"
  },
  "colors.violet.950": {
    "value": "#2e1065",
    "variable": "var(--cfTfyk)"
  },
  "colors.indigo.50": {
    "value": "#eef2ff",
    "variable": "var(--kbclAu)"
  },
  "colors.indigo.100": {
    "value": "#e0e7ff",
    "variable": "var(--gAzkHe)"
  },
  "colors.indigo.200": {
    "value": "#c7d2fe",
    "variable": "var(--gRHwoJ)"
  },
  "colors.indigo.300": {
    "value": "#a5b4fc",
    "variable": "var(--iYtjYI)"
  },
  "colors.indigo.400": {
    "value": "#818cf8",
    "variable": "var(--jCTsMf)"
  },
  "colors.indigo.500": {
    "value": "#6366f1",
    "variable": "var(--ujwXi)"
  },
  "colors.indigo.600": {
    "value": "#4f46e5",
    "variable": "var(--LrIEN)"
  },
  "colors.indigo.700": {
    "value": "#4338ca",
    "variable": "var(--cSdwoM)"
  },
  "colors.indigo.800": {
    "value": "#3730a3",
    "variable": "var(--irwviH)"
  },
  "colors.indigo.900": {
    "value": "#312e81",
    "variable": "var(--kyiiSG)"
  },
  "colors.indigo.950": {
    "value": "#1e1b4b",
    "variable": "var(--hgSANP)"
  },
  "colors.blue.50": {
    "value": "#eff6ff",
    "variable": "var(--glmLoi)"
  },
  "colors.blue.100": {
    "value": "#dbeafe",
    "variable": "var(--bYrJpO)"
  },
  "colors.blue.200": {
    "value": "#bfdbfe",
    "variable": "var(--hoTvPd)"
  },
  "colors.blue.300": {
    "value": "#93c5fd",
    "variable": "var(--bMEoOM)"
  },
  "colors.blue.400": {
    "value": "#60a5fa",
    "variable": "var(--hIEEwj)"
  },
  "colors.blue.500": {
    "value": "#3b82f6",
    "variable": "var(--cgpxvS)"
  },
  "colors.blue.600": {
    "value": "#2563eb",
    "variable": "var(--hwRjVh)"
  },
  "colors.blue.700": {
    "value": "#1d4ed8",
    "variable": "var(--bUCcUQ)"
  },
  "colors.blue.800": {
    "value": "#1e40af",
    "variable": "var(--golFsv)"
  },
  "colors.blue.900": {
    "value": "#1e3a8a",
    "variable": "var(--LWyse)"
  },
  "colors.blue.950": {
    "value": "#172554",
    "variable": "var(--eJQij)"
  },
  "colors.sky.50": {
    "value": "#f0f9ff",
    "variable": "var(--dosFxZ)"
  },
  "colors.sky.100": {
    "value": "#e0f2fe",
    "variable": "var(--bMxFwZ)"
  },
  "colors.sky.200": {
    "value": "#bae6fd",
    "variable": "var(--vPNZS)"
  },
  "colors.sky.300": {
    "value": "#7dd3fc",
    "variable": "var(--bdmqGz)"
  },
  "colors.sky.400": {
    "value": "#38bdf8",
    "variable": "var(--bduzvQ)"
  },
  "colors.sky.500": {
    "value": "#0ea5e9",
    "variable": "var(--bKRccx)"
  },
  "colors.sky.600": {
    "value": "#0284c7",
    "variable": "var(--ujkFq)"
  },
  "colors.sky.700": {
    "value": "#0369a1",
    "variable": "var(--bbFNlX)"
  },
  "colors.sky.800": {
    "value": "#075985",
    "variable": "var(--RWYCI)"
  },
  "colors.sky.900": {
    "value": "#0c4a6e",
    "variable": "var(--bztBjp)"
  },
  "colors.sky.950": {
    "value": "#082f49",
    "variable": "var(--iNVpnc)"
  },
  "colors.cyan.50": {
    "value": "#ecfeff",
    "variable": "var(--dyXAhp)"
  },
  "colors.cyan.100": {
    "value": "#cffafe",
    "variable": "var(--eeWoox)"
  },
  "colors.cyan.200": {
    "value": "#a5f3fc",
    "variable": "var(--fnHbwe)"
  },
  "colors.cyan.300": {
    "value": "#67e8f9",
    "variable": "var(--cLmYYf)"
  },
  "colors.cyan.400": {
    "value": "#22d3ee",
    "variable": "var(--bpLSHw)"
  },
  "colors.cyan.500": {
    "value": "#06b6d4",
    "variable": "var(--kcNzIt)"
  },
  "colors.cyan.600": {
    "value": "#0891b2",
    "variable": "var(--llymQa)"
  },
  "colors.cyan.700": {
    "value": "#0e7490",
    "variable": "var(--iJeksb)"
  },
  "colors.cyan.800": {
    "value": "#155e75",
    "variable": "var(--jTKpqw)"
  },
  "colors.cyan.900": {
    "value": "#164e63",
    "variable": "var(--hrqmSx)"
  },
  "colors.cyan.950": {
    "value": "#083344",
    "variable": "var(--bcqAnE)"
  },
  "colors.teal.50": {
    "value": "#f0fdfa",
    "variable": "var(--jqQOis)"
  },
  "colors.teal.100": {
    "value": "#ccfbf1",
    "variable": "var(--hsCMHs)"
  },
  "colors.teal.200": {
    "value": "#99f6e4",
    "variable": "var(--jcJhxj)"
  },
  "colors.teal.300": {
    "value": "#5eead4",
    "variable": "var(--czjDVi)"
  },
  "colors.teal.400": {
    "value": "#2dd4bf",
    "variable": "var(--kfgCt)"
  },
  "colors.teal.500": {
    "value": "#14b8a6",
    "variable": "var(--eWbmzo)"
  },
  "colors.teal.600": {
    "value": "#0d9488",
    "variable": "var(--gGhHpf)"
  },
  "colors.teal.700": {
    "value": "#0f766e",
    "variable": "var(--cIdNe)"
  },
  "colors.teal.800": {
    "value": "#115e59",
    "variable": "var(--catTvB)"
  },
  "colors.teal.900": {
    "value": "#134e4a",
    "variable": "var(--gMpZsw)"
  },
  "colors.teal.950": {
    "value": "#042f2e",
    "variable": "var(--bnTNlF)"
  },
  "colors.emerald.50": {
    "value": "#ecfdf5",
    "variable": "var(--jVPfey)"
  },
  "colors.emerald.100": {
    "value": "#d1fae5",
    "variable": "var(--gSyYHy)"
  },
  "colors.emerald.200": {
    "value": "#a7f3d0",
    "variable": "var(--dOyJRJ)"
  },
  "colors.emerald.300": {
    "value": "#6ee7b7",
    "variable": "var(--jOMcLk)"
  },
  "colors.emerald.400": {
    "value": "#34d399",
    "variable": "var(--bLsBkr)"
  },
  "colors.emerald.500": {
    "value": "#10b981",
    "variable": "var(--hLFUdS)"
  },
  "colors.emerald.600": {
    "value": "#059669",
    "variable": "var(--eHFFod)"
  },
  "colors.emerald.700": {
    "value": "#047857",
    "variable": "var(--kHSYhE)"
  },
  "colors.emerald.800": {
    "value": "#065f46",
    "variable": "var(--iuBcgT)"
  },
  "colors.emerald.900": {
    "value": "#064e3b",
    "variable": "var(--dfsLBy)"
  },
  "colors.emerald.950": {
    "value": "#022c22",
    "variable": "var(--jJEloz)"
  },
  "colors.green.50": {
    "value": "#f0fdf4",
    "variable": "var(--hXozqf)"
  },
  "colors.green.100": {
    "value": "#dcfce7",
    "variable": "var(--iDDIAz)"
  },
  "colors.green.200": {
    "value": "#bbf7d0",
    "variable": "var(--khfuXU)"
  },
  "colors.green.300": {
    "value": "#86efac",
    "variable": "var(--hypAVx)"
  },
  "colors.green.400": {
    "value": "#4ade80",
    "variable": "var(--wGfza)"
  },
  "colors.green.500": {
    "value": "#22c55e",
    "variable": "var(--jdlUVz)"
  },
  "colors.green.600": {
    "value": "#16a34a",
    "variable": "var(--kGNHsU)"
  },
  "colors.green.700": {
    "value": "#15803d",
    "variable": "var(--hXXNqx)"
  },
  "colors.green.800": {
    "value": "#166534",
    "variable": "var(--bAQeLK)"
  },
  "colors.green.900": {
    "value": "#14532d",
    "variable": "var(--khvUij)"
  },
  "colors.green.950": {
    "value": "#052e16",
    "variable": "var(--cbdKOS)"
  },
  "colors.lime.50": {
    "value": "#f7fee7",
    "variable": "var(--dhEleJ)"
  },
  "colors.lime.100": {
    "value": "#ecfccb",
    "variable": "var(--gFFbyh)"
  },
  "colors.lime.200": {
    "value": "#d9f99d",
    "variable": "var(--fjFsBy)"
  },
  "colors.lime.300": {
    "value": "#bef264",
    "variable": "var(--cfdGZz)"
  },
  "colors.lime.400": {
    "value": "#a3e635",
    "variable": "var(--bxLPEk)"
  },
  "colors.lime.500": {
    "value": "#84cc16",
    "variable": "var(--jIFNBh)"
  },
  "colors.lime.600": {
    "value": "#65a30d",
    "variable": "var(--imGeEy)"
  },
  "colors.lime.700": {
    "value": "#4d7c0f",
    "variable": "var(--fietcz)"
  },
  "colors.lime.800": {
    "value": "#3f6212",
    "variable": "var(--crovfQ)"
  },
  "colors.lime.900": {
    "value": "#365314",
    "variable": "var(--kCitcN)"
  },
  "colors.lime.950": {
    "value": "#1a2e05",
    "variable": "var(--gEQkrg)"
  },
  "colors.yellow.50": {
    "value": "#fefce8",
    "variable": "var(--cLFWMs)"
  },
  "colors.yellow.100": {
    "value": "#fef9c3",
    "variable": "var(--kxGpio)"
  },
  "colors.yellow.200": {
    "value": "#fef08a",
    "variable": "var(--cbZZGT)"
  },
  "colors.yellow.300": {
    "value": "#fde047",
    "variable": "var(--fwcFBW)"
  },
  "colors.yellow.400": {
    "value": "#facc15",
    "variable": "var(--hUTJsd)"
  },
  "colors.yellow.500": {
    "value": "#eab308",
    "variable": "var(--loWpng)"
  },
  "colors.yellow.600": {
    "value": "#ca8a04",
    "variable": "var(--cTpZLL)"
  },
  "colors.yellow.700": {
    "value": "#a16207",
    "variable": "var(--gnsFGO)"
  },
  "colors.yellow.800": {
    "value": "#854d0e",
    "variable": "var(--ByZWN)"
  },
  "colors.yellow.900": {
    "value": "#713f12",
    "variable": "var(--dVBFRQ)"
  },
  "colors.yellow.950": {
    "value": "#422006",
    "variable": "var(--iLqZUR)"
  },
  "colors.amber.50": {
    "value": "#fffbeb",
    "variable": "var(--kVxzTd)"
  },
  "colors.amber.100": {
    "value": "#fef3c7",
    "variable": "var(--jZPQXp)"
  },
  "colors.amber.200": {
    "value": "#fde68a",
    "variable": "var(--hCWpXC)"
  },
  "colors.amber.300": {
    "value": "#fcd34d",
    "variable": "var(--bCKrrD)"
  },
  "colors.amber.400": {
    "value": "#fbbf24",
    "variable": "var(--wuHbc)"
  },
  "colors.amber.500": {
    "value": "#f59e0b",
    "variable": "var(--fLErTZ)"
  },
  "colors.amber.600": {
    "value": "#d97706",
    "variable": "var(--doKQUm)"
  },
  "colors.amber.700": {
    "value": "#b45309",
    "variable": "var(--iDUBNj)"
  },
  "colors.amber.800": {
    "value": "#92400e",
    "variable": "var(--iOnUJo)"
  },
  "colors.amber.900": {
    "value": "#78350f",
    "variable": "var(--cObWdp)"
  },
  "colors.amber.950": {
    "value": "#451a03",
    "variable": "var(--frxesg)"
  },
  "colors.orange.50": {
    "value": "#fff7ed",
    "variable": "var(--NQTLQ)"
  },
  "colors.orange.100": {
    "value": "#ffedd5",
    "variable": "var(--JsfmQ)"
  },
  "colors.orange.200": {
    "value": "#fed7aa",
    "variable": "var(--gBjjlD)"
  },
  "colors.orange.300": {
    "value": "#fdba74",
    "variable": "var(--QMCLK)"
  },
  "colors.orange.400": {
    "value": "#fb923c",
    "variable": "var(--ijESlZ)"
  },
  "colors.orange.500": {
    "value": "#f97316",
    "variable": "var(--czilMg)"
  },
  "colors.orange.600": {
    "value": "#ea580c",
    "variable": "var(--iqZpKT)"
  },
  "colors.orange.700": {
    "value": "#c2410c",
    "variable": "var(--cGCJla)"
  },
  "colors.orange.800": {
    "value": "#9a3412",
    "variable": "var(--dUhLNN)"
  },
  "colors.orange.900": {
    "value": "#7c2d12",
    "variable": "var(--jzgOMQ)"
  },
  "colors.orange.950": {
    "value": "#431407",
    "variable": "var(--igBpVl)"
  },
  "colors.red.50": {
    "value": "#fef2f2",
    "variable": "var(--bINrJX)"
  },
  "colors.red.100": {
    "value": "#fee2e2",
    "variable": "var(--fKgVwH)"
  },
  "colors.red.200": {
    "value": "#fecaca",
    "variable": "var(--bLdQLg)"
  },
  "colors.red.300": {
    "value": "#fca5a5",
    "variable": "var(--fMUQaR)"
  },
  "colors.red.400": {
    "value": "#f87171",
    "variable": "var(--hwCQam)"
  },
  "colors.red.500": {
    "value": "#ef4444",
    "variable": "var(--iYfRb)"
  },
  "colors.red.600": {
    "value": "#dc2626",
    "variable": "var(--hzqKEw)"
  },
  "colors.red.700": {
    "value": "#b91c1c",
    "variable": "var(--lMavl)"
  },
  "colors.red.800": {
    "value": "#991b1b",
    "variable": "var(--bLDcWa)"
  },
  "colors.red.900": {
    "value": "#7f1d1d",
    "variable": "var(--fNuclL)"
  },
  "colors.red.950": {
    "value": "#450a0a",
    "variable": "var(--jHDsLG)"
  },
  "colors.neutral.50": {
    "value": "#fafafa",
    "variable": "var(--kltIHN)"
  },
  "colors.neutral.100": {
    "value": "#f5f5f5",
    "variable": "var(--hzpwrB)"
  },
  "colors.neutral.200": {
    "value": "#e5e5e5",
    "variable": "var(--lbfZji)"
  },
  "colors.neutral.300": {
    "value": "#d4d4d4",
    "variable": "var(--fcfsVb)"
  },
  "colors.neutral.400": {
    "value": "#a3a3a3",
    "variable": "var(--kPKNfw)"
  },
  "colors.neutral.500": {
    "value": "#737373",
    "variable": "var(--eQKgRp)"
  },
  "colors.neutral.600": {
    "value": "#525252",
    "variable": "var(--isAJIW)"
  },
  "colors.neutral.700": {
    "value": "#404040",
    "variable": "var(--ctAduP)"
  },
  "colors.neutral.800": {
    "value": "#262626",
    "variable": "var(--bqFRBA)"
  },
  "colors.neutral.900": {
    "value": "#171717",
    "variable": "var(--gHaUMp)"
  },
  "colors.neutral.950": {
    "value": "#0a0a0a",
    "variable": "var(--fhFoEQ)"
  },
  "colors.stone.50": {
    "value": "#fafaf9",
    "variable": "var(--NNaBX)"
  },
  "colors.stone.100": {
    "value": "#f5f5f4",
    "variable": "var(--juQpUX)"
  },
  "colors.stone.200": {
    "value": "#e7e5e4",
    "variable": "var(--jjsRgY)"
  },
  "colors.stone.300": {
    "value": "#d6d3d1",
    "variable": "var(--hxarzx)"
  },
  "colors.stone.400": {
    "value": "#a8a29e",
    "variable": "var(--dmyqvy)"
  },
  "colors.stone.500": {
    "value": "#78716c",
    "variable": "var(--bAfQNX)"
  },
  "colors.stone.600": {
    "value": "#57534e",
    "variable": "var(--boIrZY)"
  },
  "colors.stone.700": {
    "value": "#44403c",
    "variable": "var(--kRLBRt)"
  },
  "colors.stone.800": {
    "value": "#292524",
    "variable": "var(--iKBpmW)"
  },
  "colors.stone.900": {
    "value": "#1c1917",
    "variable": "var(--gYiPFv)"
  },
  "colors.stone.950": {
    "value": "#0c0a09",
    "variable": "var(--kshUcS)"
  },
  "colors.zinc.50": {
    "value": "#fafafa",
    "variable": "var(--dhFdXS)"
  },
  "colors.zinc.100": {
    "value": "#f4f4f5",
    "variable": "var(--dGhjba)"
  },
  "colors.zinc.200": {
    "value": "#e4e4e7",
    "variable": "var(--efoVXJ)"
  },
  "colors.zinc.300": {
    "value": "#d4d4d8",
    "variable": "var(--ljOqfc)"
  },
  "colors.zinc.400": {
    "value": "#a1a1aa",
    "variable": "var(--cXLRGr)"
  },
  "colors.zinc.500": {
    "value": "#71717a",
    "variable": "var(--kcllNK)"
  },
  "colors.zinc.600": {
    "value": "#52525b",
    "variable": "var(--kBsYKt)"
  },
  "colors.zinc.700": {
    "value": "#3f3f46",
    "variable": "var(--gqwJsQ)"
  },
  "colors.zinc.800": {
    "value": "#27272a",
    "variable": "var(--ylgyn)"
  },
  "colors.zinc.900": {
    "value": "#18181b",
    "variable": "var(--hCKAFG)"
  },
  "colors.zinc.950": {
    "value": "#09090b",
    "variable": "var(--dtmsQb)"
  },
  "colors.gray.50": {
    "value": "#f9fafb",
    "variable": "var(--dcmCJN)"
  },
  "colors.gray.100": {
    "value": "#f3f4f6",
    "variable": "var(--ePJGsV)"
  },
  "colors.gray.200": {
    "value": "#e5e7eb",
    "variable": "var(--dnVpUm)"
  },
  "colors.gray.300": {
    "value": "#d1d5db",
    "variable": "var(--bMJKSL)"
  },
  "colors.gray.400": {
    "value": "#9ca3af",
    "variable": "var(--jSiOQk)"
  },
  "colors.gray.500": {
    "value": "#6b7280",
    "variable": "var(--iqXjOJ)"
  },
  "colors.gray.600": {
    "value": "#4b5563",
    "variable": "var(--gPiTqa)"
  },
  "colors.gray.700": {
    "value": "#374151",
    "variable": "var(--fnXooz)"
  },
  "colors.gray.800": {
    "value": "#1f2937",
    "variable": "var(--fKIyfA)"
  },
  "colors.gray.900": {
    "value": "#111827",
    "variable": "var(--ejwTdZ)"
  },
  "colors.gray.950": {
    "value": "#030712",
    "variable": "var(--jympbw)"
  },
  "colors.slate.50": {
    "value": "#f8fafc",
    "variable": "var(--kcXOlL)"
  },
  "colors.slate.100": {
    "value": "#f1f5f9",
    "variable": "var(--kbRDfH)"
  },
  "colors.slate.200": {
    "value": "#e2e8f0",
    "variable": "var(--ivwbEU)"
  },
  "colors.slate.300": {
    "value": "#cbd5e1",
    "variable": "var(--dpNMHJ)"
  },
  "colors.slate.400": {
    "value": "#94a3b8",
    "variable": "var(--dtmoEy)"
  },
  "colors.slate.500": {
    "value": "#64748b",
    "variable": "var(--jCZJgj)"
  },
  "colors.slate.600": {
    "value": "#475569",
    "variable": "var(--hWEhFw)"
  },
  "colors.slate.700": {
    "value": "#334155",
    "variable": "var(--cQVSIl)"
  },
  "colors.slate.800": {
    "value": "#1e293b",
    "variable": "var(--hVLXiS)"
  },
  "colors.slate.900": {
    "value": "#0f172a",
    "variable": "var(--cQdIlH)"
  },
  "colors.slate.950": {
    "value": "#020617",
    "variable": "var(--iFDdka)"
  },
  "colors.background": {
    "value": "var(--background)",
    "variable": "var(--jEjhje)"
  },
  "colors.text.200": {
    "value": "var(--text-200)",
    "variable": "var(--doOHnq)"
  },
  "colors.text.300": {
    "value": "var(--text-300)",
    "variable": "var(--jWIyMn)"
  },
  "colors.text.500": {
    "value": "var(--text-500)",
    "variable": "var(--dZhvOt)"
  },
  "colors.text.700": {
    "value": "var(--text-700)",
    "variable": "var(--hAgYEj)"
  },
  "colors.accent.50": {
    "value": "var(--accent-50)",
    "variable": "var(--jLCNCW)"
  },
  "colors.accent.100": {
    "value": "var(--accent-100)",
    "variable": "var(--LSEFy)"
  },
  "colors.accent.200": {
    "value": "var(--accent-200)",
    "variable": "var(--ktKNMF)"
  },
  "colors.accent.300": {
    "value": "var(--accent-300)",
    "variable": "var(--gPLgwU)"
  },
  "colors.accent.400": {
    "value": "var(--accent-400)",
    "variable": "var(--kXbJnT)"
  },
  "colors.accent.500": {
    "value": "var(--accent-500)",
    "variable": "var(--htcbYi)"
  },
  "colors.accent.600": {
    "value": "var(--accent-600)",
    "variable": "var(--fLyBGt)"
  },
  "colors.accent.700": {
    "value": "var(--accent-700)",
    "variable": "var(--chyUqI)"
  },
  "colors.accent.800": {
    "value": "var(--accent-800)",
    "variable": "var(--qWncv)"
  },
  "colors.accent.900": {
    "value": "var(--accent-900)",
    "variable": "var(--icsplG)"
  },
  "colors.accent.950": {
    "value": "var(--accent-950)",
    "variable": "var(--cykvkr)"
  },
  "colors.overAccent.50": {
    "value": "var(--over-accent-50)",
    "variable": "var(--fEZnQM)"
  },
  "colors.overAccent.100": {
    "value": "var(--over-accent-100)",
    "variable": "var(--kKRPvw)"
  },
  "colors.overAccent.200": {
    "value": "var(--over-accent-200)",
    "variable": "var(--YizAr)"
  },
  "colors.overAccent.300": {
    "value": "var(--over-accent-300)",
    "variable": "var(--hmsuoq)"
  },
  "colors.overAccent.400": {
    "value": "var(--over-accent-400)",
    "variable": "var(--cBcORZ)"
  },
  "colors.overAccent.500": {
    "value": "var(--over-accent-500)",
    "variable": "var(--iPmJFY)"
  },
  "colors.overAccent.600": {
    "value": "var(--over-accent-600)",
    "variable": "var(--krZdjP)"
  },
  "colors.overAccent.700": {
    "value": "var(--over-accent-700)",
    "variable": "var(--fqNoyS)"
  },
  "colors.overAccent.800": {
    "value": "var(--over-accent-800)",
    "variable": "var(--jDvuAB)"
  },
  "colors.overAccent.900": {
    "value": "var(--over-accent-900)",
    "variable": "var(--eCjFPE)"
  },
  "colors.overAccent.950": {
    "value": "var(--over-accent-950)",
    "variable": "var(--kVcwyh)"
  },
  "colors.secondary.50": {
    "value": "var(--secondary-50)",
    "variable": "var(--irWsyu)"
  },
  "colors.secondary.100": {
    "value": "var(--secondary-100)",
    "variable": "var(--ilYAjm)"
  },
  "colors.secondary.200": {
    "value": "var(--secondary-200)",
    "variable": "var(--gchcUR)"
  },
  "colors.secondary.300": {
    "value": "var(--secondary-300)",
    "variable": "var(--iJHjKI)"
  },
  "colors.secondary.400": {
    "value": "var(--secondary-400)",
    "variable": "var(--fvXpvX)"
  },
  "colors.secondary.500": {
    "value": "var(--secondary-500)",
    "variable": "var(--idxwlO)"
  },
  "colors.secondary.600": {
    "value": "var(--secondary-600)",
    "variable": "var(--fTFYXt)"
  },
  "colors.secondary.700": {
    "value": "var(--secondary-700)",
    "variable": "var(--iBgfNk)"
  },
  "colors.secondary.800": {
    "value": "var(--secondary-800)",
    "variable": "var(--lghOvL)"
  },
  "colors.secondary.900": {
    "value": "var(--secondary-900)",
    "variable": "var(--cymlMG)"
  },
  "colors.secondary.950": {
    "value": "var(--secondary-950)",
    "variable": "var(--eQxkYf)"
  },
  "colors.overSecondary.50": {
    "value": "var(--over-secondary-50)",
    "variable": "var(--kqEnTg)"
  },
  "colors.overSecondary.100": {
    "value": "var(--over-secondary-100)",
    "variable": "var(--jPcZVY)"
  },
  "colors.overSecondary.200": {
    "value": "var(--over-secondary-200)",
    "variable": "var(--cfzkUv)"
  },
  "colors.overSecondary.300": {
    "value": "var(--over-secondary-300)",
    "variable": "var(--jeUCRW)"
  },
  "colors.overSecondary.400": {
    "value": "var(--over-secondary-400)",
    "variable": "var(--iOlbEJ)"
  },
  "colors.overSecondary.500": {
    "value": "var(--over-secondary-500)",
    "variable": "var(--dCGlYs)"
  },
  "colors.overSecondary.600": {
    "value": "var(--over-secondary-600)",
    "variable": "var(--hiygvL)"
  },
  "colors.overSecondary.700": {
    "value": "var(--over-secondary-700)",
    "variable": "var(--cSxOUq)"
  },
  "colors.overSecondary.800": {
    "value": "var(--over-secondary-800)",
    "variable": "var(--bcNYOh)"
  },
  "colors.overSecondary.900": {
    "value": "var(--over-secondary-900)",
    "variable": "var(--hgESGM)"
  },
  "colors.overSecondary.950": {
    "value": "var(--over-secondary-950)",
    "variable": "var(--hoKHIR)"
  },
  "colors.grey.50": {
    "value": "var(--grey-50)",
    "variable": "var(--cdYgVB)"
  },
  "colors.grey.100": {
    "value": "var(--grey-100)",
    "variable": "var(--fNYchh)"
  },
  "colors.grey.200": {
    "value": "var(--grey-200)",
    "variable": "var(--emjLIy)"
  },
  "colors.grey.300": {
    "value": "var(--grey-300)",
    "variable": "var(--cKYgGX)"
  },
  "colors.grey.400": {
    "value": "var(--grey-400)",
    "variable": "var(--iTUtbY)"
  },
  "colors.grey.500": {
    "value": "var(--grey-500)",
    "variable": "var(--hsIOax)"
  },
  "colors.grey.600": {
    "value": "var(--grey-600)",
    "variable": "var(--fQUxBO)"
  },
  "colors.grey.700": {
    "value": "var(--grey-700)",
    "variable": "var(--epISAn)"
  },
  "colors.grey.800": {
    "value": "var(--grey-800)",
    "variable": "var(--gIWTTM)"
  },
  "colors.grey.900": {
    "value": "var(--grey-900)",
    "variable": "var(--fhLoSl)"
  },
  "colors.grey.950": {
    "value": "var(--grey-950)",
    "variable": "var(--izXTnk)"
  },
  "colors.info.300": {
    "value": "var(--info-300)",
    "variable": "var(--QazpA)"
  },
  "colors.info.500": {
    "value": "var(--info-500)",
    "variable": "var(--cvgLlK)"
  },
  "colors.info.700": {
    "value": "var(--info-700)",
    "variable": "var(--XYnvE)"
  },
  "colors.error.300": {
    "value": "var(--error-300)",
    "variable": "var(--jQEcwi)"
  },
  "colors.error.500": {
    "value": "var(--error-500)",
    "variable": "var(--cpJfeg)"
  },
  "colors.error.700": {
    "value": "var(--error-700)",
    "variable": "var(--cHpFvW)"
  },
  "colors.warning.300": {
    "value": "var(--warning-300)",
    "variable": "var(--cVijUk)"
  },
  "colors.warning.500": {
    "value": "var(--warning-500)",
    "variable": "var(--gJICNi)"
  },
  "colors.warning.700": {
    "value": "var(--warning-700)",
    "variable": "var(--gTbIGw)"
  },
  "colors.valid.300": {
    "value": "var(--valid-300)",
    "variable": "var(--guhFMM)"
  },
  "colors.valid.500": {
    "value": "var(--valid-500)",
    "variable": "var(--zBrwa)"
  },
  "colors.valid.700": {
    "value": "var(--valid-700)",
    "variable": "var(--isfSrw)"
  },
  "breakpoints.sm": {
    "value": "640px",
    "variable": "var(--ikokJA)"
  },
  "breakpoints.md": {
    "value": "768px",
    "variable": "var(--kSvAmr)"
  },
  "breakpoints.lg": {
    "value": "1024px",
    "variable": "var(--uwdhN)"
  },
  "breakpoints.xl": {
    "value": "1280px",
    "variable": "var(--eyfDzy)"
  },
  "breakpoints.2xl": {
    "value": "1536px",
    "variable": "var(--dgHGKE)"
  },
  "breakpoints.tablet": {
    "value": "768px",
    "variable": "var(--iNvcGI)"
  },
  "breakpoints.desktop": {
    "value": "1280px",
    "variable": "var(--dlPwCk)"
  },
  "spacing.-1": {
    "value": "calc(var(--dacYEG) * -1)",
    "variable": "var(--dacYEG)"
  },
  "spacing.-2": {
    "value": "calc(var(--ebuyxV) * -1)",
    "variable": "var(--ebuyxV)"
  },
  "spacing.-3": {
    "value": "calc(var(--bYDCFo) * -1)",
    "variable": "var(--bYDCFo)"
  },
  "spacing.-4": {
    "value": "calc(var(--hIimNX) * -1)",
    "variable": "var(--hIimNX)"
  },
  "spacing.-5": {
    "value": "calc(var(--fFrqVq) * -1)",
    "variable": "var(--fFrqVq)"
  },
  "spacing.-6": {
    "value": "calc(var(--gGIQOF) * -1)",
    "variable": "var(--gGIQOF)"
  },
  "spacing.-7": {
    "value": "calc(var(--eDRUVY) * -1)",
    "variable": "var(--eDRUVY)"
  },
  "spacing.-8": {
    "value": "calc(var(--flZesP) * -1)",
    "variable": "var(--flZesP)"
  },
  "spacing.-9": {
    "value": "calc(var(--djiiAi) * -1)",
    "variable": "var(--djiiAi)"
  },
  "spacing.-10": {
    "value": "calc(var(--ieMJEa) * -1)",
    "variable": "var(--ieMJEa)"
  },
  "spacing.-11": {
    "value": "calc(var(--cBFxYr) * -1)",
    "variable": "var(--cBFxYr)"
  },
  "spacing.-12": {
    "value": "calc(var(--uyqLg) * -1)",
    "variable": "var(--uyqLg)"
  },
  "spacing.-14": {
    "value": "calc(var(--hXmVPi) * -1)",
    "variable": "var(--hXmVPi)"
  },
  "spacing.-16": {
    "value": "calc(var(--mYCWo) * -1)",
    "variable": "var(--mYCWo)"
  },
  "spacing.-20": {
    "value": "calc(var(--jgejxp) * -1)",
    "variable": "var(--jgejxp)"
  },
  "spacing.-24": {
    "value": "calc(var(--iYEvIx) * -1)",
    "variable": "var(--iYEvIx)"
  },
  "spacing.-28": {
    "value": "calc(var(--dzpWeZ) * -1)",
    "variable": "var(--dzpWeZ)"
  },
  "spacing.-32": {
    "value": "calc(var(--fifqnK) * -1)",
    "variable": "var(--fifqnK)"
  },
  "spacing.-36": {
    "value": "calc(var(--faFCyS) * -1)",
    "variable": "var(--faFCyS)"
  },
  "spacing.-40": {
    "value": "calc(var(--bxwoov) * -1)",
    "variable": "var(--bxwoov)"
  },
  "spacing.-44": {
    "value": "calc(var(--huPzrf) * -1)",
    "variable": "var(--huPzrf)"
  },
  "spacing.-48": {
    "value": "calc(var(--hgdKvb) * -1)",
    "variable": "var(--hgdKvb)"
  },
  "spacing.-52": {
    "value": "calc(var(--cZMJbQ) * -1)",
    "variable": "var(--cZMJbQ)"
  },
  "spacing.-56": {
    "value": "calc(var(--iXfUeA) * -1)",
    "variable": "var(--iXfUeA)"
  },
  "spacing.-60": {
    "value": "calc(var(--vWSpd) * -1)",
    "variable": "var(--vWSpd)"
  },
  "spacing.-64": {
    "value": "calc(var(--gtqdrN) * -1)",
    "variable": "var(--gtqdrN)"
  },
  "spacing.-72": {
    "value": "calc(var(--hNtIEu) * -1)",
    "variable": "var(--hNtIEu)"
  },
  "spacing.-80": {
    "value": "calc(var(--kqIPsj) * -1)",
    "variable": "var(--kqIPsj)"
  },
  "spacing.-96": {
    "value": "calc(var(--wdMRQ) * -1)",
    "variable": "var(--wdMRQ)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--gEfgCY) * -1)",
    "variable": "var(--gEfgCY)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--jJIQbV) * -1)",
    "variable": "var(--jJIQbV)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--cqwGG) * -1)",
    "variable": "var(--cqwGG)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--dhUgfD) * -1)",
    "variable": "var(--dhUgfD)"
  },
  "colors.colorPalette": {
    "value": "var(--idUrcU)",
    "variable": "var(--idUrcU)"
  },
  "colors.colorPalette.50": {
    "value": "var(--bgowFI)",
    "variable": "var(--bgowFI)"
  },
  "colors.colorPalette.100": {
    "value": "var(--iSScQY)",
    "variable": "var(--iSScQY)"
  },
  "colors.colorPalette.200": {
    "value": "var(--bdPmBD)",
    "variable": "var(--bdPmBD)"
  },
  "colors.colorPalette.300": {
    "value": "var(--EuecW)",
    "variable": "var(--EuecW)"
  },
  "colors.colorPalette.400": {
    "value": "var(--dIdJaV)",
    "variable": "var(--dIdJaV)"
  },
  "colors.colorPalette.500": {
    "value": "var(--iOGEjQ)",
    "variable": "var(--iOGEjQ)"
  },
  "colors.colorPalette.600": {
    "value": "var(--ZDNUv)",
    "variable": "var(--ZDNUv)"
  },
  "colors.colorPalette.700": {
    "value": "var(--AiFvO)",
    "variable": "var(--AiFvO)"
  },
  "colors.colorPalette.800": {
    "value": "var(--iCIPjV)",
    "variable": "var(--iCIPjV)"
  },
  "colors.colorPalette.900": {
    "value": "var(--ctQaTU)",
    "variable": "var(--ctQaTU)"
  },
  "colors.colorPalette.950": {
    "value": "var(--eHAyIp)",
    "variable": "var(--eHAyIp)"
  }
};
function token(path, fallback) {
  var _a;
  return ((_a = tokens[path]) == null ? void 0 : _a.value) || fallback;
}
function tokenVar(path, fallback) {
  var _a;
  return ((_a = tokens[path]) == null ? void 0 : _a.variable) || fallback;
}
token.var = tokenVar;
const tabletBreakapoint = parseInt(token("breakpoints.tablet", "768px"));
const desktopBreakapoint = parseInt(token("breakpoints.desktop", "1280px"));
const useViewport = () => {
  const windowWidth = useWindowWidth();
  if (windowWidth < tabletBreakapoint) {
    return "mobile";
  }
  if (windowWidth < desktopBreakapoint) {
    return "tablet";
  }
  return "desktop";
};
export {
  useViewport
};
